import http from './http.js'
export default {
    //美图秀秀
    //clickid 拿到uuid 和ClickId//价格数据
    getCity() {
        return http.get("/activity/getAddressesInfo" )
    },
    upImage(address,type){
        return http.post("/marketing/list/queryUrl?address="+ address +"&platformType="+ type)
    },
    upImage1(type,i){
        return http.post("/marketing/list/queryUrl?platformType="+ type+"&marketingId=" + i)
    },
    getHits(id,type){
        return http.get("/marketing/list/getHits?marketingId="+ id )
    },

 
}


// WEBPACK FOOTER //
// ./src/api/api.js